export const QR_DOWNLOAD_IMAGE_SIZE = 1000;
export const QR_CANVAS_SIZE = 196;
export const QR_IMAGE_TYPE = 'image/png';
export const QR_IMAGE_EXT = 'png';
